<template>
  <div class="store-message baselayout">
    <!-- 选择门店 -->
    <div class="connect" v-if="isShowConnect">
        <jx-select-pick 
                v-model="storeID"
                :placeholder="'请输入门店关键字'"
                :valueType="{
                    type:'object',
                    valueKey:'id'
                }"
            >
        </jx-select-pick>
        <el-button 
            type="primary" 
            :disabled="isDisabledEntry" 
            size="mini" 
            class="connect-button" 
            :loading="isloading" 
            @click="entryChatBox" 
        >{{ isloading? '正在连接' : '连接会话' }}
        </el-button>
    </div>

    <div class="chat" v-else >
        <div class="title">
            <div class="title-left">{{storeID.id  + '(' + storeID.name + ')'}}</div>
            <div class="title-center">
                <el-tooltip placement="left" effect="light">
                    <div slot="content" class="mtIM">
                        <div class="mtIM-title">当前IM状态：</div>
                        <div v-if="chatObj['mt'] && chatObj['mt'][0].imDetail[0].errMsg">未知状态</div>
                        <el-switch v-else 
                            v-model="chatObj['mt'][0].imDetail[0].imStatus" 
                            :active-value="1" 
                            :inactive-value="0" 
                            @change="changeSwitch($event,1)">
                        </el-switch>
                    </div>
                    <div :style="{
                        color:chatObj['mt'][0].imDetail[0].imStatus? '':'#909399'
                    }">美团</div>
                </el-tooltip>
                <span v-if="chatObj['eb']">/</span>
                <el-tooltip placement="right" effect="light" v-if="chatObj['eb']">
                    <div slot="content" class="ebIM">
                        <div class="ebIM-title">当前IM状态：</div>
                        <el-switch 
                            v-model="chatObj['eb'][0].imDetail[0].imStatus" 
                            :active-value="1" 
                            :inactive-value="0" 
                            @change="changeSwitch($event,3)">
                        </el-switch>
                    </div>
                    <div :style="{
                        color:chatObj['eb'][0].imDetail[0].imStatus? '':'#909399'
                    }">淘宝闪购</div>
                </el-tooltip>
                <span>聊天</span>
            </div>
            <div class="title-right" @click="closeChat">
                <div  class="close-icon"></div>
                <span>关闭</span>     
            </div>
             
        </div>
        
        <el-container class="chatContainer">
            <el-aside  width="600px" class="userList">
                <div v-for="(item,index) in allUserList" :key="index" class="chatItem" @click="queryDetailBut(item)"
                    :style="{
                        'background':item.userID === '' + currentUser.userID ? '#fff' : ''
                    }">
                    <el-badge :value="item.NewMessageNum" class="badge" :hidden="!item.NewMessageNum" >
                        <div class="badge-box">
                            <img 
                                :src="item.vendorID === 1 ? 'https://image.jxc4.com/image/75654ab606494a0efdb0cf7d7ad060d9.png':'https://image.jxc4.com/image/6c2f1dfd95890df8ef5e27bde15c4e7f.png'" 
                                alt=""
                                class="badge-img" >
                        </div>
                    </el-badge>

                    <div class="userInfo">
                        <div class="userName">
                            <div v-if="item.vendorID === 1">{{item.userID !== '0' ? `【美团${item.orderDesc}】${item.userID}`:'【美团】群发消息' }}</div>
                            <div v-else>{{ `【淘宝闪购】${item.userID}` }}</div>
                            <div>{{ item.latestTime }}</div>
                        </div>
                        <div class="textMessage">{{item.latestMsg}}</div>
                    </div>
                </div>
            </el-aside>

            <el-container>
                <!-- 聊天详情 -->
                <el-main class="chatDetail">
                    <!-- 头像 -->
                    <div v-for="(item,index) in chatDetail" :key="index" 
                        class="chatDetail-item"
                        :style="{
                            'flex-direction':item.msg_source == 1?'row-reverse':'',
                            'text-align':item.msg_source == 1?'right':'',
                            'margin':'20px',
                            'padding':'20px',
                        }">
                        <div >
                            <img :src="avatar(item)" mode="aspectFill" alt="" class="chatDetail-avatar" />
                        </div>
                            
                        <div :style="{
                            'margin-left': item.msg_source === 1?'':'20px',
                            'margin-right':item.msg_source === 1?'20px':''
                        }">
                            <div style="margin-bottom: 10px;"
                                :style="{
                                    'text-align':item.msg_source === 1?'right':'left'
                                }"
                                @click="jumpOrderDetail(item.order_id)"
                            >
                                {{ item.msg_source == 2 ?item.order_id?item.sendType.toUpperCase() + '客户(' + item.order_id +')': item.sendType.toUpperCase() + '客户':
                                    currentUser.vendorID == 1 ? chatObj['mt'][0].storeName.length ? chatObj['mt'][0].storeName : chatObj['mt'][0].vendorStoreName
                                        :chatObj['eb'][0].storeName
                                }}
                            </div>


                            <div :style="{
                                'display':'flex',
                                'justify-content':item.msg_source === 1?'flex-end':'flex-start'
                            }">
                                <!-- 聊天内容 -->
                                <el-card  
                                    :style="{
                                        'max-width':'500px',
                                        'width':'fit-content',
                                        'display':item.msg_type == 5 && item.msg_content?'':'flex',
                                        'width':item.msg_type == 5 && item.msg_content?'400px':'',
                                    }">

                                    <!-- 文字 -->
                                    <div v-if="item.msg_type == 1 || item.msg_type == 11" 
                                        :style="{
                                        'text-align':'left',
                                        'letter-spacing': '4px'
                                    }">
                                        {{ item.msg_content }}
                                    </div>

                                    <!-- 图片 -->
                                    <el-popover 
                                        placement="right" 
                                        width="300" 
                                        trigger="hover" 
                                        v-else-if="item.msg_type == 2 || item.msg_type == 12">
                                        <div>
                                            <img :src="item.msg_content" alt="缩略图..." width="100%" />
                                        </div>
                                        <img slot="reference" :src="item.msg_content" alt="略缩图"  style="width:100px;height:240px" />
                                    </el-popover>

                                    <!-- 语音 -->
                                    <div  v-else-if="item.msg_type == 3 || item.msg_type == 13" class="voice" >
                                        <audio id="myAudio" controls>
                                            <source :src="item.msg_content" type="audio/mpeg">
                                        </audio>
                                    </div>

                                    <!-- 商品卡片 -->
                                    <div v-else-if="item.msg_type == 4 || item.msg_type == 14"> 
                                        skuid:{{ item.msg_content }}
                                        <div v-if="item.goodCard" style="margin-top: 10px;">
                                            <img :src="item.goodCard.img" alt="缩略图..." width="100%" />
                                            <span>{{ item.goodCard.name }}</span>
                                        </div>
                                         <!-- <span class="good_card" @click.stop="viewGood(item,index)">查看商品</span> -->
                                    </div> 

                                    <!-- 订单卡片 -->
                                    <template v-else-if="item.msg_type == 5 && item.msg_content">
                                        <div slot="header" class="clearfix">
                                            <span>订单卡片</span>
                                            <router-link :to="'/ordermanager/' + JSON.parse(item.msg_content).order_view_id" target="_blank">
                                                <el-button style="float: right; padding: 3px 0" type="text" >查看详情</el-button>
                                            </router-link>
                                        </div>
                                        <div style="letter-spacing: 4px">
                                            <div> {{ JSON.parse(item.msg_content).food_desc }}</div>
                                            <div class="order-card">{{ JSON.parse(item.msg_content).status_desc + '...'}}</div>
                                        </div>
                                    </template>

                                    <!-- 兜底 -->
                                    <view class="chat-text-container" v-else> 【未知信息】 </view>
                                </el-card>

                            </div>
                        </div>
                    </div>
                    
                </el-main>

                <el-footer>
                    <el-input placeholder="请输入内容......" v-model="sendText" class="input-with-select" >
                        <el-button slot="append" type="primary" @click="sendMsg">发送</el-button>
                    </el-input>
                </el-footer>
            </el-container>
        </el-container>
    </div>
    
  </div>
</template>

<script>
import jxSelectPick from '@/components/cmp/selectPick'
import {
        getStoreImStatus,
        getChatUserList,
        getChatDetail,
        getUrlByMediaID,
        setImMsgRead,
        sendToVendorV2,
        setPoiIMStatus} from '@/apis/store'
import { hideLoad } from '@/tools/loading'
import {Decrypt,Encrypt,timeFormatDHM} from '@/tools/ase'
import {debounce,throttle} from '@/utils/underscore'
import {  apiGetOrder} from '@/apis/controls/order'
import {APIGetStoresSkus} from '@/apis/APIstoreSku.js'
// import { msgInfo } from './mockData'
export default {
    components:{
        jxSelectPick
    },
    data(){
        return {
            storeID:[],
            isloading:false,
            chatObj:{},
            isShowConnect:true,
            allUserList:[],
            imStatusList:[],
            mtIM: true,
            ebIM: true,
            chatDetail:[],
            sendText:"",
            currentUser:{},         // 当前用户
            isCloudMt:false,
            isCloudEb:false,
            userListParams:[],
            userTimer:null,
            detailTimer:null
        }
    },
    computed:{
        isDisabledEntry(){
            let falg =  this.storeID.length>=0?true:false
            return falg
        }
    },
    methods:{
        /*************************************************
         * 查看商品
         */
        async viewGood(rowItem,index) {
            if(this.chatDetail[index].goodCard) return
            const skuid = rowItem.app_spu_codes
            let data = {
                storeIDs: JSON.stringify([this.chatObj['mt'][0].storeID]),
                isFocus: true,
                skuIDs: [+skuid],
                offset: 0,
                pageSize: 1,
            }
            let res = await APIGetStoresSkus(data,true)
            this.chatDetail[index].goodCard = res.skuNames[0]
        },
        // 跳到订单详情
        jumpOrderDetail(orderID){
            if(orderID)  window.open('#/ordermanager/' + orderID, '_blank');
        },
        // 连接会话
        entryChatBox:debounce(
            async function() {
                this.isloading = true
                let mt = this.storeID.StoreMaps.filter(item => item.vendorID === 1)
                let eb = this.storeID.StoreMaps.filter(item => item.vendorID === 3)

                // 查询该门店是否含有美团门店
                if(mt.length!==0) this.isCloudMt = true
                if(eb.length!==0) this.isCloudEb = true

                if(!this.isCloudMt && !this.isCloudMt) {
                    return this.$message({
                        message: `该门店未绑定美团/淘宝闪购`,
                        type: 'warning',
                        center: true,
                    })
                }
                this.allUserList = []
                await this.queryStoreIm() // 查询IM状态
            
                // 获取用户列表
               let res = await this.getChatUserList(false)       
               if(!res){
                    this.userTimer = setInterval(() => {
                        this.getChatUserList(true)
                    },4000)
               } 
            },
            1000,
            true
        ),
        // 查询门店的IM状态
        async queryStoreIm(){
            // 参数
            let json = []
            if(this.isCloudMt) {
                this.chatObj['mt'] = this.storeID.StoreMaps.filter(item => item.vendorID === 1)
                json.push({
                    vendorID:1,
                    vendorOrgCode:this.chatObj['mt'][0].vendorOrgCode + '',
                    vendorStoreID:this.chatObj['mt'][0].vendorStoreID + ''
                })
            }
            if(this.isCloudEb) {
                this.chatObj['eb'] = this.storeID.StoreMaps.filter(item => item.vendorID === 3)
                json.push({
                    vendorID:3,
                    vendorOrgCode:this.chatObj['eb'][0].vendorOrgCode + '',
                    vendorStoreID:this.chatObj['eb'][0].vendorStoreID + ''
                })
            }
            let imDetail = await getStoreImStatus(json)

            if(this.isCloudMt) {
                this.chatObj['mt'][0].imDetail = imDetail.filter(item => item.vendorID===1)
                
                imDetail.forEach(item => {
                    if(item.vendorID === 0 && item.errMsg ){
                        // accessToken 过期
                        this.chatObj['mt'][0].imDetail=[{
                            ...item,
                            vendorID:+item.errMsg.substring(0, 1)
                        }]
                    }
                })
            }

            if(this.isCloudEb) this.chatObj['eb'][0].imDetail = imDetail.filter(item => item.vendorID===3)
        },
        // 设置门店IM单聊状态
        async changeSwitch(e,platID){
            let chatObj = []
            if(platID === 1) chatObj = this.chatObj['mt'][0]
            if(platID === 3) chatObj = this.chatObj['eb'][0]
            let data = [
                {
                    vendorID: platID,
                    vendorStoreID: chatObj.vendorStoreID,
                    vendorOrgCode:chatObj.vendorOrgCode,
                    imStatus:e
                }
            ]
            await setPoiIMStatus(data)
            await this.queryStoreIm()
            this.$toast("修改成功");
        },
        // 获取聊天的用户列表
        async getChatUserList(isloading){
            // console.log('获取用户列表')
            let payLoad = []
            if(this.userListParams.length === 0){
                 // console.log('获取聊天列表',this.chatObj)
                let isQueryMt = this.chatObj['mt'] && this.chatObj['mt'][0].imDetail.length && !this.chatObj['mt'][0].imDetail[0].errMsg
                let isQueryEb = this.chatObj['eb'] && this.chatObj['eb'][0].imDetail.length
            
                if(isQueryMt){
                    payLoad.push({
                        vendorStoreID:"" + this.chatObj['mt'][0].vendorStoreID,
                        vendorID:"1",
                        appID:"" + this.chatObj['mt'][0].vendorOrgCode
                    })
                    
                }
                if(isQueryEb){
                    payLoad.push({
                        vendorStoreID:"" + this.chatObj['eb'][0].vendorStoreID,
                        vendorID:"3",
                        appID:"" + this.chatObj['eb'][0].vendorOrgCode
                    })
                }
                if(payLoad.length === 0) return  this.isloading = false
                this.userListParams = payLoad
            }else  payLoad = this.userListParams 
           
            let res = await getChatUserList(payLoad,isloading)
            if(JSON.stringify(res) === '{}') {
                if(this.userTimer) clearInterval(this.userTimer)
                hideLoad()
                this.isloading = false
                this.$toast('该门店暂无消息')
                return  '该门店暂无消息'
            }
            let fmtUserList = []
            let febUserList = []
            // 美团
            if(this.isCloudMt){
                fmtUserList = this.chatObj['mt'].length ? res[`${this.chatObj['mt'][0].vendorOrgCode}:${ this.chatObj['mt'][0].vendorStoreID}:1`] || [] : []  // 美团
                this.mtUserList(fmtUserList,this.chatObj['mt'][0].vendorOrgCode)    // 解密消息
            }
           
            // 淘宝闪购
            if(this.isCloudEb){
                febUserList = this.chatObj['eb'].length ? res[`${this.chatObj['eb'][0].vendorOrgCode}:${ this.chatObj['eb'][0].vendorStoreID}:3`] || [] : [] // 淘宝闪购
                this.getEbUserList(febUserList)
            }
            this.isShowConnect = false
            if(this.allUserList.length>0) {
                let findIndex = 0
                if(JSON.stringify(this.currentUser) !== '{}') {
                    if(this.detailTimer) clearInterval(this.detailTimer)
                    findIndex = this.allUserList.findIndex((item) => item.userID === this.currentUser.userID)
                }
                this.queryDetailThrottle(this.allUserList[findIndex],isloading)
            }
            hideLoad()
        },
        // 获取淘宝闪购列表
        getEbUserList(reverseListEb){
            // 淘宝闪购
            reverseListEb.map((element) => {
                let resData = JSON.parse(element)
                let findIndex = this.allUserList.findIndex(item => item.payLoad.groupId === resData.payLoad.groupId)
                if(findIndex === -1){
                    let latestMsgHandler = JSON.parse(resData.latestMsg).text ? JSON.parse(resData.latestMsg).text : JSON.parse(resData.latestMsg).duration ? '【语音】' : '【图片】'
                    // let isAddUserLiset = JSON.parse(resData.latestMsg).data && JSON.parse(JSON.parse(resData.latestMsg).data).title.includes('本次服务已经完成，会话暂停') ? false : true
                    if (JSON.parse(resData.latestMsg).elements && JSON.parse(resData.latestMsg).elements.length > 0) {
                        let findItem = JSON.parse(resData.latestMsg).elements.filter((item) => item.elementType === 1)
                        latestMsgHandler = findItem && findItem.length > 0 ? JSON.parse(findItem[0].elementContent).text.replace('@商家', '') : latestMsgHandler
                    }
                    // 
                    // 淘宝闪购参考文档：https://open-retail.ele.me/#/apidoc/me.ele.retail:im.message.send-3?aopApiCategory=IM_all&type=api_menu resData.userID != 0 &&  isAddUserLiset
                    let userList = {
                        ...resData,
                        latestMsg: latestMsgHandler,
                        latestTime: timeFormatDHM(+new Date(resData.latestTime * 1000)),
                        originTime:resData.latestTime,
                        orderInfo: {},
                        orderDesc: ''
                    }
                    this.allUserList.push(userList)
                    
                    if (userList.orderID) this.getOrderInfo(userList.orderID, this.allUserList.length - 1 ) // 获取订单信息
                }
            })
        },
        // 获取订单信息
        async  getOrderInfo(orderId, index) {
            let res = await apiGetOrder({ vendorOrderID: orderId })
            this.allUserList[index].orderInfo = res.data[0]
            this.allUserList[index].orderDesc = ` #${res.data[0].orderSeq}`
        },
        // 查询聊天详情按钮
        queryDetailBut:debounce(
            function name(query) {
                // this.queryDetail(query)
                this.queryDetailThrottle(query)
                this.detailTimer =setInterval(() => {
                    this.queryDetailThrottle(query,true)
                },4000)
            }
            ,1000,
            true
        ),
        queryDetailThrottle:throttle(
            function name(query,isloading) {
                this.queryDetail(query,isloading)
            }
        ),
        // 查询聊天详情
        async queryDetail(item,isloading = false){
            // console.log('查看聊天详情,,,,99999',item)
            if(!(this.currentUser.userID && this.currentUser.userID === item.userID)){
                this.chatDetail = []
                this.currentUser = item
            }
            
            let payLoad = [{
                vendorStoreID:item.vendorID === 1?this.chatObj['mt'][0].vendorStoreID:this.chatObj['eb'][0].vendorStoreID,
                vendorID:'' + item.vendorID,
                appID:item.vendorID === 1?this.chatObj['mt'][0].vendorOrgCode:this.chatObj['eb'][0].vendorOrgCode,
                userID:item.userID
            }]
            let str = `${payLoad[0].appID}:${payLoad[0].vendorStoreID}:${payLoad[0].vendorID}:${payLoad[0].userID}`
            let res = await getChatDetail(payLoad,isloading)
            // let res = msgInfo.chatDetail.data    // 模拟聊天详情
            // 美团
            if(item.vendorID === 1){
               
                res[str].forEach(element => {
                    let resData = this.jxParse(element)
                    let findIndex = this.chatDetail.findIndex(item => item.msg_id === resData.msgContent.msg_id)
                    if(findIndex === -1){
                        // let msg_content = resData.msgContent.msg_type == 1 ? analyEmoji(Decrypt(resData.msgContent.msg_content, platformID.value)) : Decrypt(resData.msgContent.msg_content, platformID.value)   // 解析emoji表情
                        let msg_content = Decrypt(resData.msgContent.msg_content, payLoad[0].appID) // 解密
                        if (resData.msgContent.msg_type === 4 || resData.msgContent.msg_type === 14) msg_content = resData.msgContent.app_spu_codes // 商品skuid
                        this.chatDetail.push({
                            sendType: resData.sendType,
                            ...resData.msgContent,
                            msg_content,
                        })
                        if(resData.msgContent.msg_type === 4 || resData.msgContent.msg_type === 14) this.viewGood({app_spu_codes:msg_content},this.chatDetail.length)
                    }
                })
            }else{
                res[str].map(async (element,index) => {
                    let resData = JSON.parse(element)
                    if (resData.msgContent) {
                        // if (resData.msgContent.payload) resData.msgContent.payLoad = resData.msgContent.payload
                        let findIndex = this.chatDetail.findIndex(item => item.payLoad.msgId === resData.msgContent.payLoad.msgId)    // 消息id，唯一性
                        if(findIndex === -1){
                            if (resData.msgContent.payload) resData.msgContent.payLoad = resData.msgContent.payload
                            let msg = JSON.parse(resData.msgContent.payLoad.content)
                            if (msg.text) {
                                msg.text = msg.text.replace(/^["']|["']$/g, '') //正则 去掉字符串中的首尾双引号
                                resData.msgContent.payLoad.contentType = 1
                            }
                            let messageText = ''
                            if (resData.msgContent.payLoad.contentType == 1) {
                                messageText = msg.text
                            } else if (resData.msgContent.payLoad.contentType == 2 || resData.msgContent.payLoad.contentType == 3 || resData.msgContent.payLoad.contentType == 4) {
                                // contentType为2图片、3语音、4视频时
                                analyUrl({
                                    mediaID: msg.mediaId,
                                    platformShopID: '' + this.chatObj['eb'][0].vendorOrgCode
                                }, index)
                                messageText = msg.mediaId
                            } else {
                                if(resData.msgContent.payLoad.contentType == 101 && msg.type == 7){
                                    // 101、自定义消息-商品卡片
                                    analyUrl({
                                        mediaID: msg.data.item.id,
                                        platformShopID: '' + this.chatObj['eb'][0].vendorOrgCode
                                    }, index)
                                }else if(msg.elements && msg.elements.length){
                                    let findItem = msg.elements.filter(item => item.elementType === 1)
                                    messageText = findItem && findItem.length > 0 ? JSON.parse(findItem[0].elementContent).text.replace('@商家', '') : ''
                                }
                            }

                            this.chatDetail.push({
                                sendType: resData.sendType,
                                ...resData.msgContent,
                                // msg_content: resData.msgContent.payLoad.contentType === 1 || resData.msgContent.payLoad.contentType === '8' ? analyEmoji(str) : str,
                                msg_content: messageText,
                                msg_source: resData.sendType === 'jx' ? 1 : 2,
                                msg_type: resData.msgContent.payLoad.contentType === '8' ? 1 : resData.msgContent.payLoad.contentType
                            })
                        }
 
                    }
                })
            }
            if(item.NewMessageNum) this.setImMsgRead(item) // 设置已读
            hideLoad()
        },
        // 设置消息为已读
        async setImMsgRead(item){
            if(!this.chatDetail.length) return
            let data = {
                appID: item.vendorID === 1 ? this.chatObj['mt'][0].vendorOrgCode : this.chatObj['eb'][0].vendorOrgCode,
                vendorStoreID: item.vendorID === 1 ? this.chatObj['mt'][0].vendorStoreID : this.chatObj['eb'][0].vendorStoreID,
                vendorID: "" + item.vendorID,
                orderID: "" + item.orderID ? item.orderID : '0',
                userID: item.userID
            }
            let form = new FormData()
            form.append('appID', data.appID)
            form.append('vendorStoreID', data.vendorStoreID)
            form.append('vendorID', data.vendorID)
            form.append('orderID', data.orderID)
            form.append('userID', data.userID)
            await setImMsgRead(form,true)
            let findIndex = this.allUserList.findIndex(i => i.userID === item.userID)
            if(findIndex !== -1) this.allUserList[findIndex].NewMessageNum = 0
        },
        // 获取url by mediaId
        async analyUrl(params, index) {
            if (this.chatDetail[index] && !this.chatDetail[index].msg_content) return
            let res = await getUrlByMediaID(params)
            if (this.chatDetail[index].msg_content.length === 0) this.chatDetail[index].msg_content = res.code === '0' ? res.data : ''
        },
        // 关闭聊天
        closeChat(){
            this.storeID = []
            this.allUserList = []
            this.isCloudMt = false
            this.isCloudEb = false
            clearInterval(this.userTimer)   // 清除用户列表定时器
            clearInterval(this.detailTimer)   // 清除用户列表定时器
            this.isShowConnect = true
        },
        // 播放语音
        playVoice(playUrl){
            this.$toast('正在播放音频')
            isVoice.value = true
            voice.src = playUrl
            voice.stop()
            voice.play()
            voice.onEnded(() => {
                isVoice.value = false
            })
        }, 
        // 头像
        avatar(url){
            if (url.msg_source == 1) {
                return 'http://image.jxc4.com/image/70143fcf48aefe74537533f35a0a8153.jpg'
            } else {
                if (url.sendType == 'mt') {
                    return 'https://image.jxc4.com/image/75654ab606494a0efdb0cf7d7ad060d9.png'
                } else {
                    return 'https://image.jxc4.com/image/6c2f1dfd95890df8ef5e27bde15c4e7f.png'
                }
            }
        },
        // 发送消息
        async sendMsg(){
            if(!this.sendText.length) return
            let message = this.sendText.replace(/\n/g, '')  // 发送的消息   除去回车字符

            let data = {
                sendType: this.currentUser.vendorID === 1 ? "mt" : "elm",
                app_id: this.currentUser.vendorID === 1 ? this.chatObj['mt'][0].vendorOrgCode : this.chatObj['eb'][0].vendorOrgCode,
                app_poi_code: this.currentUser.vendorID === 1 ? this.chatObj['mt'][0].vendorStoreID : this.chatObj['eb'][0].vendorStoreID,
                cts: Math.round(new Date().getTime() / 1000).toString(),
                // msg_content: msgData.type === 1 ? analyEmoji(msgData.msg) : msgData.msg,
                msg_content: message,
                msg_id: Math.round(new Date().getTime()).toString(),
                msg_source: 1,
                // msg_type: msgData.type,     // 1文本   2 图片网址
                msg_type: 1,     // 1文本   2 图片网址
                open_user_id: this.currentUser.userID,
                order_id: this.currentUser.orderID,
                app_spu_codes: ""
            }

            this.chatDetail.push({
                ...data
            })      // 添加新消息

            // 2、滚动到底部

            let sendMsg = {}  // 发生的消息结构体
            if (this.currentUser.vendorID === 1) {
                sendMsg = {
                    vendorOrgCode: this.chatObj['mt'][0].vendorOrgCode,
                    sendData: JSON.stringify({
                        vendorID: this.currentUser.vendorID,
                        data: {
                            msg_content: Encrypt(message, this.chatObj['mt'][0].vendorOrgCode),
                            // msg_type: +Number(msgData.type),
                            msg_type: 1,
                            app_poi_code: "" + this.chatObj['mt'][0].vendorStoreID,
                            msg_id: +Math.round(new Date().getTime()).toString() + 184572,
                            app_id: this.chatObj['mt'][0].vendorOrgCode,
                            msg_source: 1,
                            order_id: this.currentUser.orderID,
                            cts: +Math.round(new Date().getTime() / 1000).toString(),
                            open_user_id: +this.currentUser.userID,
                        }
                    })
                }
            } else {
                let chatDataItem = this.chatDetail.filter(item => item.msg_source === 2)
                sendMsg = {
                    platformShopId: chatDataItem[0].platformShopId,
                    subBizType: 'SEND_MESSAGE',
                    bizType: 'IM',
                    payload: {
                        receiverIds: chatDataItem[0].payLoad.receiverIds,
                        groupId: chatDataItem[0].payLoad.groupId,
                        msgId: '' + Math.round(new Date().getTime()).toString() + 184572,
                        contentType: '' + msgData.type, // 1-普通文本 2-图片 3-语音 4-视频 101-自定义
                        // contentType: '2', // 1-普通文本 2-图片 3-语音 4-视频 101-自定义
                        content: msgData.type == 1 ?
                            JSON.stringify({
                                text: msgData.msg
                            })
                            :
                            JSON.stringify({
                                mediaId: msgData.msg,
                                fileType: 0,   // 必传 int类型 0-jpg图片, 2-png图片
                                size: 1      // 必传 int类型 图片大小, 单位字节, 不超过3*1024*1024
                            })
                    }
                }
                sendMsg = {
                    vendorOrgCode: this.chatObj['eb'][0].vendorOrgCode,
                    sendData: JSON.stringify({
                        vendorID: useData.vendorID,
                        data: { ...sendMsg }
                    })
                }
            }

            console.log(sendMsg,'发送消息，查看内容',message)
            // sendToVendorV2(sendMsg)
            // 发送成功
        },
        // 美团用户列表 循环
        mtUserList(userList,platformID){
            let userListR = userList.reverse()
            userListR.forEach(element => {
                let resData = JSON.parse(element)
                let findIndex = this.allUserList.findIndex(item => item.userID === resData.userID)
                if(findIndex === -1){
                    let latestMsgHandler = this.decryptMessageText(resData,platformID)
                    this.allUserList.push({
                        ...resData,
                        latestMsg: latestMsgHandler,
                        latestTime: timeFormatDHM(+new Date(resData.latestTime * 1000)),
                        originTime:resData.latestTime,
                        orderInfo: {},
                        orderDesc: ''
                    })
                    if (resData.orderID) this.getOrderInfo(resData.orderID,this.allUserList.length - 1 ) // 获取订单信息
                }else if(resData.latestTime !== this.allUserList[findIndex].originTime){
                    this.allUserList[findIndex].latestMsg = this.decryptMessageText(resData,platformID)
                }
            });      
        },
        // 解密 美团消息
        decryptMessageText(resData,platformID){
            let afterText = Decrypt(resData.latestMsg, platformID)    // 解密之后的文本
            if (afterText.indexOf('[自动回复]') == -1) { 
                let latestMsgHandler = ''
                try {
                    JSON.parse(afterText)
                    latestMsgHandler = typeof JSON.parse(afterText) === 'number' ? afterText : '【订单】'
                } catch (error) {
                    if (afterText == '') {
                        latestMsgHandler = '【商品】'
                    } else {
                        if (!(afterText.includes('https') || afterText.includes('http')))  latestMsgHandler = afterText
                          else latestMsgHandler = afterText.indexOf('.amr') == -1 ? '【图片】' : '【语音】'
                    }
                }
                return latestMsgHandler
            }else{
                return afterText
            }
        },
        // json序列化 返回的订单号为number型，会失真，不能直接调用JSON.parse
        jxParse(text) {
            let newText = text.replace(/:s*([0-9]{15,})s*(,?)/g, ': "$1" $2')
            return JSON.parse(newText)
        }
    },
    destroyed(){
        clearInterval(this.userTimer)
        clearInterval(this.detailTimer)
    }

}
</script>

<style lang="scss" scope>
@import './index.scss'
</style>


// WEBPACK FOOTER //
// src/components/storemanager/storeMessage/index.vue